import { MonitorPlay } from 'lucide-react'
import { RequirePermission } from '@/features/auth/guards'
import { FamilyLmsCoursePage } from '@/pages/lms/FamilyLmsCoursePage'
import { FamilyLmsPage } from '@/pages/lms/FamilyLmsPage'
import { LmsAssignmentPage } from '@/pages/lms/LmsAssignmentPage'
import { LmsCoursePage } from '@/pages/lms/LmsCoursePage'
import { LmsCoursesPage } from '@/pages/lms/LmsCoursesPage'
import type { AppModule } from '../moduleRegistry'

const teacherRoutes = [
  { index: true, element: <LmsCoursesPage /> },
  { path: 'courses/:sectionId/:subjectId', element: <LmsCoursePage /> },
  { path: 'assignments/:id', element: <LmsAssignmentPage /> },
]

export const module: AppModule = {
  id: 'lms',
  schoolModule: 'lms',
  routes: {
    admin: [{ path: 'lms', element: <RequirePermission permission="lms.manage" />, children: teacherRoutes }],
    staff: [{ path: 'lms', element: <RequirePermission permission="lms.teach" />, children: teacherRoutes }],
    family: [
      { path: 'learning', element: <FamilyLmsPage /> },
      { path: 'learning/:subjectId', element: <FamilyLmsCoursePage /> },
    ],
  },
  nav: {
    admin: [
      {
        group: 'Academics',
        order: 50,
        item: {
          label: 'Online learning',
          to: '/admin/lms',
          icon: MonitorPlay,
          permission: 'lms.manage',
          keywords: 'lms e-learning courses homework assignments lessons',
        },
      },
    ],
    staff: [
      {
        order: 14,
        item: {
          label: 'Online learning',
          to: '/staff/lms',
          icon: MonitorPlay,
          permission: 'lms.teach',
          keywords: 'lms e-learning courses homework assignments lessons',
        },
      },
    ],
    family: [
      {
        order: 18,
        item: {
          label: 'Online learning',
          to: '/portal/learning',
          icon: MonitorPlay,
          keywords: 'lms e-learning courses homework assignments lessons',
        },
      },
    ],
  },
}
